import {Box} from "@mui/material"
import {NotificationType} from "../../../reducers/notificationsSlice"

export function NotificationItemBody({sharedCitationObject, sentByUser}) {

	return (
		<Box sx={{ flex:"1 0 50%", minHeight: "1.5rem", }}>
			{ (sharedCitationObject.type === NotificationType.ARTICLE_SHARE && !sentByUser) && (
				<div>
					{`${sharedCitationObject.userName} shared ${sharedCitationObject?.articles?.length} article${sharedCitationObject?.articles?.length > 1 ? "s" : ""}`} with you.
				</div>
			)}
			{ (sharedCitationObject.type === NotificationType.ARTICLE_SHARE && sentByUser) && (
				<div>
					{`You shared ${sharedCitationObject?.articles?.length} article${sharedCitationObject?.articles?.length > 1 ? "s" : ""} with ${sharedCitationObject.userName}`}
				</div>
			)}
			{ (sharedCitationObject.type === NotificationType.WORKSPACE_ADD && !sentByUser) && (
				<div>
					{`${sharedCitationObject.userName} added you to the ${sharedCitationObject.sendingWorkspace.title} workspace`}
				</div>
			)}
			{ (sharedCitationObject.type === NotificationType.WORKSPACE_ADD && sentByUser) && (
				<div>
					{`${sharedCitationObject.userName} has been added to the ${sharedCitationObject.sendingWorkspace.title} workspace`}
				</div>
			)}
			{ (sharedCitationObject.type === NotificationType.WORKSPACE_INVITE && !sentByUser) && (
				<div>
					{`${sharedCitationObject.userName} invited you to the ${sharedCitationObject.sendingWorkspace.title} workspace`}
				</div>
			)}
			{ (sharedCitationObject.type === NotificationType.WORKSPACE_INVITE && sentByUser) && (
				<div>
					{`You invited ${sharedCitationObject.userName} to the ${sharedCitationObject.sendingWorkspace.title} workspace`}
				</div>
			)}
			{ (sharedCitationObject.type === NotificationType.WORKSPACE_INVITE_RESPONSE && !sentByUser) && (
				<div>
					{`${sharedCitationObject.userName} is requesting access to the ${sharedCitationObject.sendingWorkspace.title} workspace`}
				</div>
			)}
			{(sharedCitationObject.type === NotificationType.WORKSPACE_INVITE_RESPONSE && sentByUser) && (
				<div>
					{`You accepted ${sharedCitationObject.userName}'s invite to access the ${sharedCitationObject.sendingWorkspace.title} workspace`}
				</div>
			)}
			{( sharedCitationObject.type === NotificationType.POST_REGISTER_INVITE && sentByUser) && (
				<div>
					{`${sharedCitationObject.userName} registered an account and was sent an invite to join the default workspace`}
				</div>
			)}
			{( sharedCitationObject.type ===NotificationType.POST_REGISTER_INVITE && !sentByUser) && (
				<div>
					{sharedCitationObject.message}
				</div>
			)}
		</Box>
	)
}